export default "__VITE_PUBLIC_ASSET__0042cc17__"